export const MAP_ICON_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_4e685e72-daea-435a-89e8-a6ad15e1bded/artifacts/5zko0o6y_map.png";

export function googleMapsUrl(address) {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    address || ""
  )}`;
}

export default function MapButton({
  address,
  size = 20,
  className = "",
  testid,
  stopPropagation = false,
}) {
  const href = googleMapsUrl(address);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        if (stopPropagation) e.stopPropagation();
      }}
      className={`inline-flex items-center justify-center shrink-0 hover:opacity-80 transition-opacity ${className}`}
      title="Abrir rota no Google Maps"
      data-testid={testid}
      aria-label="Abrir rota no Google Maps"
    >
      <img
        src={MAP_ICON_URL}
        alt=""
        style={{ width: size, height: size, display: "block" }}
      />
    </a>
  );
}
